export const GET_MENU = 'get_menu';
export const SET_MENU = 'set_menu';
export const OPEN_MODAL= "open_modal";

